import { render } from "./SubcategoryUpdate.vue?vue&type=template&id=fac39960"
import script from "./SubcategoryUpdate.vue?vue&type=script&lang=js"
export * from "./SubcategoryUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__